export default __webpack_public_path__ + "4c98027f3df0d27c3aec079f645e1845.wav";